//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import productEventsMixin from '@motionelements/core/src/components/mixins/product-events.mixin.js';
import { isProductType } from '@motionelements/core/src/services/catalog.service.js';

export default {
  name: 'FreeProducts',
  mixins: [productEventsMixin],
  props: {
    products: {
      type: Array,
    },
    mediaType: String,
    curation: {
      type: Object,
    },
  },
  components: {
    ProductCard: () => import('@motionelements/core/src/components/product-card/ProductCard.vue'),
    ProductCardAudioBackground: () => import('@motionelements/core/src/components/product-card/sections/ProductCardBackgroundAudio.vue'),
    ProductCardAudio: () => import('@motionelements/core/src/components/product-card/ProductCardAudio.vue'),
  },
  computed: {
    perPage() {
      if (this.isAudio) {
        return 6;
      }

      if (this.products.length % 4) {
        return Math.floor(this.products.length / 4) * 4 || 4;
      }

      return 16;
    },
    isAudio() {
      return isProductType('audio', this.mediaType);
    },
    viewAllUrl() {
      return _.get(this.curation, 'html.url');
    },
  },
};
